import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { LEILAO_ARVORE_COM_BOLSAO } from './bolsao-base.route';

export const BOLSAO_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService, ConfigStateService],
    multi: true,
  },
];

/**
 * Reestrutura o menu do Leilão SOMENTE quando Bolsao E Leilao estiverem 'true' (reativo
 * pós-login): o bridge ABP→LeptonX derruba o link de nó com filhos, então remove a folha 'Leilão'
 * e adiciona a árvore pai+filhos (Ofertas abertas + Bolsão).
 *
 * Bolsão exige Leilão (decisão do Vinícius, 04/09/2026): o backend já entrega Bolsao='false' quando
 * o Leilão está desligado (BolsaoExigeLeilaoFeatureValueProvider); o AND aqui é a defesa em
 * profundidade — esta árvore RECRIA o nó pai 'Leilão', e sem o AND o menu ressuscitaria.
 *
 * As duas flags saem da MESMA emissão do estado (getOne$('features')): dois getFeature$ em
 * combineLatest veem o par intermediário do patch pós-login (o slice do Bolsão emite antes do do
 * Leilão).
 */
export function configureRoutes(routesService: RoutesService, configState: ConfigStateService) {
  return () => {
    configState
      .getOne$('features')
      .pipe(
        map(features => ({
          bolsao: features?.values?.['cargo_fleet.Bolsao'],
          leilao: features?.values?.['cargo_fleet.Leilao'],
        })),
        distinctUntilChanged((a, b) => a.bolsao === b.bolsao && a.leilao === b.leilao),
        filter(({ bolsao, leilao }) => bolsao === 'true' && leilao === 'true'),
      )
      .subscribe(() => {
        routesService.remove(['Leilão']);
        routesService.add([...LEILAO_ARVORE_COM_BOLSAO]);
      });
  };
}
